import React, { useEffect } from 'react'
import { RefreshCcwIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import crashImg from '@/shared/assets/img/svg/crashed_block_placeholder.svg'
import { ampli } from '@/shared/lib/ampli'

import { Button } from './ui/button'
import {
	Empty,
	EmptyContent,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from './ui/empty'

export default function FatalError(props: { resetError?: () => void }) {
	const { t } = useTranslation()

	useEffect(() => {
		ampli.errorErrorDisplayed()
	}, [])

	return (
		<div className='my-2 flex flex-auto items-center justify-center'>
			<Empty>
				<EmptyHeader>
					<EmptyMedia>
						<img src={crashImg} alt='crash' className='max-h-80 p-3' />
					</EmptyMedia>
					<EmptyTitle>{t('fatal_error_title')}🐞</EmptyTitle>
					<EmptyDescription>{t('fatal_error_desc')}</EmptyDescription>
				</EmptyHeader>
				<EmptyContent>
					{!!props.resetError && (
						<Button onClick={() => props.resetError?.()}>
							{t('app.retry', { defaultValue: 'Retry' })}
						</Button>
					)}
					<Button onClick={() => window.location.reload()}>
						<RefreshCcwIcon />
						{t('app.refresh_the_page', { defaultValue: 'Refresh the page' })}
					</Button>
				</EmptyContent>
			</Empty>
		</div>
	)
}
